/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HSCodeDescriptionsRequest } from '../models/HSCodeDescriptionsRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HsCodesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Batch fetch HS code descriptions (HS2/HS4/HS6) by HS6 code
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public hsCodeDescriptionsApiV1HsCodesDescriptionsPost(
        requestBody: HSCodeDescriptionsRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/hs-codes/descriptions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Batch fetch HS code descriptions (HS2/HS4/HS6) by HS6 code
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public hsCodeDescriptionsApiV1HsCodesDescriptionsPost1(
        requestBody: HSCodeDescriptionsRequest,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/hs-codes/descriptions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
